import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ProductUnderlyingAccountValuationCollectionModel } from '../../Models/Models/PortfolioAnalysis/Valution/ProductUnderlyingAccountValuationCollectionModel';
import { SubAccountType } from '../../Constants/Enums/Domain/SubAccountType';
import { ServiceProposition } from '../../Constants/Enums/ServiceProposition';
import { IJsonDate } from '../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class ProductUnderlyingAccountValuationClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, type: SubAccountType, servicePropositions: Array<ServiceProposition>, asAt: IJsonDate, minRow: number, maxRow: number): Promise<ProductUnderlyingAccountValuationCollectionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioValuation/ProductUnderlyingAccountValuation/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, type: type, servicePropositions: servicePropositions, asAt: asAt, minRow: minRow, maxRow: maxRow }

    return AjaxWrapper.get<ProductUnderlyingAccountValuationCollectionModel, any>(url, data);
  }
}

